var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllTasksAssessed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 5.565L15.0325 25.55L7.6125 18.13L10.08 15.6625L15.0325 20.615L32.5325 3.115L35 5.565ZM31.1325 14.385C31.36 15.3825 31.5 16.4325 31.5 17.5C31.5 25.235 25.235 31.5 17.5 31.5C9.765 31.5 3.5 25.235 3.5 17.5C3.5 9.765 9.765 3.5 17.5 3.5C20.265 3.5 22.82 4.305 24.99 5.6875L27.51 3.1675C24.675 1.1725 21.2275 0 17.5 0C7.84 0 0 7.84 0 17.5C0 27.16 7.84 35 17.5 35C27.16 35 35 27.16 35 17.5C35 15.4175 34.615 13.4225 33.95 11.5675L31.1325 14.385Z",
    fill: "#BCBEDC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllTasksAssessed);
export default __webpack_public_path__ + "static/media/all-tasks-assessed.041c64b6a772c6030d77cc4bd52bcfdc.svg";
export { ForwardRef as ReactComponent };